import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23e0211a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=23e0211a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0211a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/lasur-lab/lasur-lab-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e0211a')) {
      api.createRecord('23e0211a', component.options)
    } else {
      api.reload('23e0211a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=23e0211a&scoped=true", function () {
      api.rerender('23e0211a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rankGoodList/index.vue"
export default component.exports